
import UIIcon from './UIIcon.vue';

const themes = [
  'tiny',
  'primary',
  'secondary',
  'ghost',
  'link',
  'warning',
  'unstyled',
];
const themeModifiers = [
  // color modifiers
  'light',
  'white',
  'dark',
];
const themeProps = [...themes, ...themeModifiers].reduce((acc, theme) => ({
  ...acc,
  [theme]: Boolean,
}), {});

export default {
  name: 'UIButton',
  functional: true,
  props: {
    tag: String,
    icon: String,
    fullWidth: Boolean,
    ...themeProps,
  },
  render (h, ctx) {
    let children = ctx.children;
    if (ctx.props.icon) {
      children = [h(UIIcon, {
        props: { name: ctx.props.icon },
        staticClass: 'icon v-mid',
      }), children ? h('span', { staticClass: 'copy' }, children) : undefined];
    }
    let styleClasses = themes.filter((theme) => ctx.props[theme]);
    if (!styleClasses.length) styleClasses = ['primary'];
    const themeStyleClass = `-${styleClasses.join('-')}`;
    const modiferStyleClasses = themeModifiers.reduce((acc, theme) => {
      const val = ctx.props[theme];
      if (val) acc[`-${theme}`] = val;
      return acc;
    }, {});
    let inheritedClass;
    if (typeof ctx.data.class === 'string') {
      inheritedClass = { [ctx.data.class]: true };
    } else {
      inheritedClass = ctx.data.class;
    }
    const cssModuleClass = (themeStyleClass && ctx.$style[themeStyleClass] && { [ctx.$style[themeStyleClass]]: true }) || {};
    const mergedData = {
      ...ctx.data,
      class: {
        dib: true,
        'w-100': ctx.props.fullWidth,
        ...inheritedClass,
        [themeStyleClass]: true,
        ...modiferStyleClasses,
        ...cssModuleClass,
      },
      staticClass: `ui-button ${ctx.data.staticClass || ''}`,
    };

    mergedData.attrs = mergedData.attrs || {};
    if (ctx.parent.$options._scopeId) {
      mergedData.attrs[ctx.parent.$options._scopeId] = '';
    }
    if (ctx.data.attrs && ctx.data.attrs.to) {
      if (mergedData.on && mergedData.on.click) {
        mergedData.nativeOn = mergedData.nativeOn || {}; // forward click events because vue-router don't do it. Which if you ask me is stupid :()
        mergedData.nativeOn.click = mergedData.on.click; // forward click events because vue-router don't do it. Which if you ask me is stupid :()
        delete mergedData.on.click;
      }
      return h('router-link', {
        ...mergedData,
        props: {
          ...ctx.data.attrs,
        },
      }, children);
    } else if (ctx.data.attrs && ctx.data.attrs.href) {
      return h('a', mergedData, children);
    } else {
      if (!mergedData.attrs.type && !ctx.props.tag) {
        mergedData.attrs.type = 'button';
      }
      return h(ctx.props.tag || 'button', mergedData, children);
    }
  },
};
